import styles from "../CancelTaskFormItems.module.scss";

export function CancelAllTasksFormItems(): JSX.Element {
    return <span className={styles.infoSpan}>For a given contact, cancels all tasks from the queue.</span>;
}
